export default __webpack_public_path__ + "d10.png";